// component
import ContractingProjectListCom from './contracting-project-list/contracting-project-list.vue';
import ContractingFileList from './contracting-file-list/contracting-file-list.vue';
import ContractingContractList from './contracting-contract-list/contracting-contract-list.vue';
import ContractingPayList from './contracting-pay-list/contracting-pay-list.vue';
import ContractingTransactionList from './contracting-transaction-list/contracting-transaction-list.vue';

export default [
  {
    path: 'list',
    name: 'contractingProjectListCom',
    component: ContractingProjectListCom,
    meta: {
      title: '成交采购项目',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'file-list',
    name: 'contractingFileList',
    component: ContractingFileList,
    meta: {
      title: '项目文件',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'contracting-contract-list',
    name: 'ContractingContractList',
    component: ContractingContractList,
    meta: {
      title: '确认竞价结果',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'contracting-pay-list',
    name: 'ContractingPayList',
    component: ContractingPayList,
    meta: {
      title: '支付项目款',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'contracting-transaction-list',
    name: 'ContractingTransactionList',
    component: ContractingTransactionList,
    meta: {
      title: '确认合同',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  }
];

